/**
 * LAKSHIV ENTERPRISE - MAIN JS ENGINE
 */

class AppController {
  constructor() {
    this.initHeaderScroll();
    this.initMobileDrawer();
    this.initSearchModal();
    this.initAccessibility();
  }

  initHeaderScroll() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        headerWrapper.classList.add('is-scrolled');
      } else {
        headerWrapper.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  initMobileDrawer() {
    const toggleBtn = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('.mobile-drawer');
    const backdrop = document.querySelector('[data-modal-backdrop]');
    const closeBtn = document.querySelector('[data-mobile-close]');

    if (!toggleBtn || !drawer || !backdrop) return;

    const openDrawer = () => {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
  }

  initSearchModal() {
    const searchTrigger = document.querySelector('[data-search-trigger]');
    const searchModal = document.querySelector('[data-search-modal]');
    const searchClose = document.querySelector('[data-search-close]');
    const backdrop = document.querySelector('[data-modal-backdrop]');

    if (!searchTrigger || !searchModal) return;

    searchTrigger.addEventListener('click', () => {
      searchModal.classList.add('is-active');
      if (backdrop) backdrop.classList.add('is-active');
      const input = searchModal.querySelector('input');
      if (input) setTimeout(() => input.focus(), 100);
    });

    const closeSearch = () => {
      searchModal.classList.remove('is-active');
      if (backdrop) backdrop.classList.remove('is-active');
    };

    if (searchClose) searchClose.addEventListener('click', closeSearch);
  }

  initAccessibility() {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.is-open, .is-active').forEach(el => {
          el.classList.remove('is-open', 'is-active');
        });
        document.body.style.overflow = '';
      }
    });
  }

  static showToast(message, type = 'info') {
    let toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      toastContainer.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:99999;display:flex;flex-direction:column;gap:10px;';
      document.body.appendChild(toastContainer);
    }

    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.style.cssText = 'background:var(--color-primary);color:#fff;padding:12px 20px;border-radius:var(--radius-global);box-shadow:var(--shadow-floating);font-size:0.9rem;font-weight:600;animation:fadeIn 0.3s forwards;';
    toast.textContent = message;

    toastContainer.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.LakshivApp = new AppController();
});
